import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4bfffd30 from 'nuxt_plugin_plugin_4bfffd30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_74888a0a from 'nuxt_plugin_sentryserver_74888a0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_0ecf1882 from 'nuxt_plugin_sentryclient_0ecf1882' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_bootstrapvue_aca0af16 from 'nuxt_plugin_bootstrapvue_aca0af16' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_toast_b9fe8616 from 'nuxt_plugin_toast_b9fe8616' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_525f1f74 from 'nuxt_plugin_axios_525f1f74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_routertrailingSlash_64af7b65 from 'nuxt_plugin_routertrailingSlash_64af7b65' // Source: ../plugins/router.trailingSlash.js (mode: 'all')
import nuxt_plugin_moment_57893d7e from 'nuxt_plugin_moment_57893d7e' // Source: ../plugins/moment.js (mode: 'all')
import nuxt_plugin_index_0c69654a from 'nuxt_plugin_index_0c69654a' // Source: ../plugins/index.js (mode: 'all')
import nuxt_plugin_headerHelper_dabc0d74 from 'nuxt_plugin_headerHelper_dabc0d74' // Source: ../plugins/headerHelper.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_configurator_872a3f28 from 'nuxt_plugin_configurator_872a3f28' // Source: ../plugins/configurator.js (mode: 'all')
import nuxt_plugin_notifications_15a88b85 from 'nuxt_plugin_notifications_15a88b85' // Source: ../plugins/notifications.js (mode: 'all')
import nuxt_plugin_vuehtml2pdf_57ac5088 from 'nuxt_plugin_vuehtml2pdf_57ac5088' // Source: ../plugins/vue-html2pdf (mode: 'all')
import nuxt_plugin_exceptionhelpers_43d3f206 from 'nuxt_plugin_exceptionhelpers_43d3f206' // Source: ../plugins/exception-helpers.js (mode: 'all')
import nuxt_plugin_backend_4b42bad4 from 'nuxt_plugin_backend_4b42bad4' // Source: ../helpers/backend.js (mode: 'all')
import nuxt_plugin_simplebar_28d69fac from 'nuxt_plugin_simplebar_28d69fac' // Source: ../plugins/simplebar.js (mode: 'all')
import nuxt_plugin_vueclickoutside_6e1f4574 from 'nuxt_plugin_vueclickoutside_6e1f4574' // Source: ../plugins/vue-click-outside.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_vuemask_08817de4 from 'nuxt_plugin_vuemask_08817de4' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_bootstrapvue_7a18ce66 from 'nuxt_plugin_bootstrapvue_7a18ce66' // Source: ../plugins/bootstrap-vue.js (mode: 'all')
import nuxt_plugin_VueDndZone_28adc796 from 'nuxt_plugin_VueDndZone_28adc796' // Source: ../plugins/VueDndZone (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueaudiorecorder_4147d1f2 from 'nuxt_plugin_vueaudiorecorder_4147d1f2' // Source: ../plugins/vue-audio-recorder (mode: 'all')
import nuxt_plugin_draggable_5dab66d7 from 'nuxt_plugin_draggable_5dab66d7' // Source: ../plugins/draggable (mode: 'all')
import nuxt_plugin_vuedatepick_5286d8a8 from 'nuxt_plugin_vuedatepick_5286d8a8' // Source: ../plugins/vue-datepick (mode: 'all')
import nuxt_plugin_vcalendar_4dbed36c from 'nuxt_plugin_vcalendar_4dbed36c' // Source: ../plugins/v-calendar.js (mode: 'all')
import nuxt_plugin_chartjs_15364234 from 'nuxt_plugin_chartjs_15364234' // Source: ../plugins/chartjs.js (mode: 'client')
import nuxt_plugin_VueEllipseProgress_4398c84a from 'nuxt_plugin_VueEllipseProgress_4398c84a' // Source: ../plugins/VueEllipseProgress (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_vdraggable_ec08c392 from 'nuxt_plugin_vdraggable_ec08c392' // Source: ../plugins/v-draggable.js (mode: 'all')
import nuxt_plugin_datehelpers_b29252ca from 'nuxt_plugin_datehelpers_b29252ca' // Source: ../plugins/date-helpers.js (mode: 'all')
import nuxt_plugin_decodeHtmlEntities_fd72c732 from 'nuxt_plugin_decodeHtmlEntities_fd72c732' // Source: ../plugins/decodeHtmlEntities.js (mode: 'all')
import nuxt_plugin_security_1d803981 from 'nuxt_plugin_security_1d803981' // Source: ../plugins/security.js (mode: 'all')
import nuxt_plugin_auth_6dc1182a from 'nuxt_plugin_auth_6dc1182a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"CannaHealrx"},{"hid":"csp","http-equiv":"Content-Security-Policy","content":"default-src 'self';script-src 'self' 'unsafe-inline' 'unsafe-eval' https:\u002F\u002Fjs.stripe.com; object-src 'none'; base-uri 'self'; frame-src 'self' https:\u002F\u002Fjs.stripe.com; style-src 'self' * 'unsafe-inline'; img-src 'self' * data:; media-src 'self' *; font-src 'self' * data:; connect-src 'self' *; child-src 'none'; worker-src 'none';"},{"hid":"hsts","http-equiv":"Strict-Transport-Security","content":"max-age=31536000; includeSubDomains; preload"}],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4bfffd30 === 'function') {
    await nuxt_plugin_plugin_4bfffd30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_74888a0a === 'function') {
    await nuxt_plugin_sentryserver_74888a0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_0ecf1882 === 'function') {
    await nuxt_plugin_sentryclient_0ecf1882(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_aca0af16 === 'function') {
    await nuxt_plugin_bootstrapvue_aca0af16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_b9fe8616 === 'function') {
    await nuxt_plugin_toast_b9fe8616(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_525f1f74 === 'function') {
    await nuxt_plugin_axios_525f1f74(app.context, inject)
  }

  if (typeof nuxt_plugin_routertrailingSlash_64af7b65 === 'function') {
    await nuxt_plugin_routertrailingSlash_64af7b65(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_57893d7e === 'function') {
    await nuxt_plugin_moment_57893d7e(app.context, inject)
  }

  if (typeof nuxt_plugin_index_0c69654a === 'function') {
    await nuxt_plugin_index_0c69654a(app.context, inject)
  }

  if (typeof nuxt_plugin_headerHelper_dabc0d74 === 'function') {
    await nuxt_plugin_headerHelper_dabc0d74(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_configurator_872a3f28 === 'function') {
    await nuxt_plugin_configurator_872a3f28(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_15a88b85 === 'function') {
    await nuxt_plugin_notifications_15a88b85(app.context, inject)
  }

  if (typeof nuxt_plugin_vuehtml2pdf_57ac5088 === 'function') {
    await nuxt_plugin_vuehtml2pdf_57ac5088(app.context, inject)
  }

  if (typeof nuxt_plugin_exceptionhelpers_43d3f206 === 'function') {
    await nuxt_plugin_exceptionhelpers_43d3f206(app.context, inject)
  }

  if (typeof nuxt_plugin_backend_4b42bad4 === 'function') {
    await nuxt_plugin_backend_4b42bad4(app.context, inject)
  }

  if (typeof nuxt_plugin_simplebar_28d69fac === 'function') {
    await nuxt_plugin_simplebar_28d69fac(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclickoutside_6e1f4574 === 'function') {
    await nuxt_plugin_vueclickoutside_6e1f4574(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_08817de4 === 'function') {
    await nuxt_plugin_vuemask_08817de4(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_7a18ce66 === 'function') {
    await nuxt_plugin_bootstrapvue_7a18ce66(app.context, inject)
  }

  if (typeof nuxt_plugin_VueDndZone_28adc796 === 'function') {
    await nuxt_plugin_VueDndZone_28adc796(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueaudiorecorder_4147d1f2 === 'function') {
    await nuxt_plugin_vueaudiorecorder_4147d1f2(app.context, inject)
  }

  if (typeof nuxt_plugin_draggable_5dab66d7 === 'function') {
    await nuxt_plugin_draggable_5dab66d7(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedatepick_5286d8a8 === 'function') {
    await nuxt_plugin_vuedatepick_5286d8a8(app.context, inject)
  }

  if (typeof nuxt_plugin_vcalendar_4dbed36c === 'function') {
    await nuxt_plugin_vcalendar_4dbed36c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chartjs_15364234 === 'function') {
    await nuxt_plugin_chartjs_15364234(app.context, inject)
  }

  if (typeof nuxt_plugin_VueEllipseProgress_4398c84a === 'function') {
    await nuxt_plugin_VueEllipseProgress_4398c84a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_vdraggable_ec08c392 === 'function') {
    await nuxt_plugin_vdraggable_ec08c392(app.context, inject)
  }

  if (typeof nuxt_plugin_datehelpers_b29252ca === 'function') {
    await nuxt_plugin_datehelpers_b29252ca(app.context, inject)
  }

  if (typeof nuxt_plugin_decodeHtmlEntities_fd72c732 === 'function') {
    await nuxt_plugin_decodeHtmlEntities_fd72c732(app.context, inject)
  }

  if (typeof nuxt_plugin_security_1d803981 === 'function') {
    await nuxt_plugin_security_1d803981(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6dc1182a === 'function') {
    await nuxt_plugin_auth_6dc1182a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
